/** @graphql cc **/
import { graphql } from 'react-relay';
export const ContentOperationsQuery = graphql`
	query ContentOperationsQuery($contentId: ID!, $status: [String]) {
		content(id: $contentId, status: $status) {
			nodes {
				id
				type
				operations {
					operation
					targetType
				}
			}
		}
	}
`;
